export default {
  "Loop as a GIF": "Boucle en tant que GIF",
  "without sound": "sans son",
  "Final output duration": "Durée de sortie finale",
};
